"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    workspace.getModel().importLayout({
        diagram: diagram,
        validateLinks: true,
        dataProvider: new index_1.SparqlDataProvider({
            endpointUrl: '/sparql',
            imagePropertyUris: [
                'http://xmlns.com/foaf/0.1/img',
            ],
        }, tslib_1.__assign(tslib_1.__assign({}, index_1.OWLRDFSSettings), {
            fullTextSearch: {
                prefix: 'PREFIX bds: <http://www.bigdata.com/rdf/search#>' + '\n',
                queryPattern: "\n              ?inst rdfs:label ?searchLabel.\n              SERVICE bds:search {\n                     ?searchLabel bds:search \"${text}*\" ;\n                                  bds:minRelevance '0.5' ;\n\n                                  bds:matchAllTerms 'true';\n                                  bds:relevance ?score.\n              }\n            "
            },
            elementInfoQuery: "\n            CONSTRUCT {\n                ?inst rdf:type ?class;\n                    rdfs:label ?label;\n                    ?propType ?propValue.\n            }\n            WHERE {\n                OPTIONAL {?inst rdf:type ?class . }\n                OPTIONAL {?inst ${dataLabelProperty} ?label}\n                OPTIONAL {?inst ?propType ?propValue.\n                FILTER (isLiteral(?propValue)) }\n\t\t\t    VALUES ?labelProp { rdfs:label foaf:name }\n            } VALUES (?inst) {${ids}}\n        ",
        })),
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    viewOptions: {
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
